import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./StoreLocatorDayShopSchedule.module.scss";
export const StoreLocatorDayShopSchedule = ({ isOpeningHoursBreaksEnabled, day, }) => {
    if (isOpeningHoursBreaksEnabled && day.break_start_time && day.break_end_time) {
        return (_jsxs("div", { className: styles.shopBreaksSchedule, "data-testid": "shopBreaksSchedule", children: [_jsxs("div", { children: [day.open_time, " - ", day.break_start_time] }), _jsxs("div", { children: [day.break_end_time, " - ", day.close_time] })] }));
    }
    return (_jsxs(_Fragment, { children: [day.open_time, " - ", day.close_time] }));
};
//# sourceMappingURL=StoreLocatorDayShopSchedule.js.map